<template>
  <a-select
    class="autocomplete-select"
    show-search
    allowClear
    :value="value"
    :placeholder="_placeHolder"
    style="width: 100%"
    :default-active-first-option="false"
    :show-arrow="false"
    :filter-option="false"
    @search="handleSearch"
    @change="handleChange"
  >
    <a-spin v-if="loading" slot="notFoundContent" size="small" />
    <div v-else-if="hasSearched && !skuList.length" slot="notFoundContent">
      {{ $t('搜索不到该商品') }}
    </div>
    <a-select-option v-for="item in skuList" :key="item.skuCode" :option="item">
      {{ item.skuName + ' | ' + item.skuCode }}
    </a-select-option>
  </a-select>
</template>

<script>
import api from '@/service/api'
import http from '@/service/axios'
import debounce from '@/common/debounce'
import deepClone from '@/common/deepClone'

export default {
  data() {
    return {
      value: undefined,
      skuList: [],
      choosedData: null,
      loading: false,
      hasSearched: false,
    }
  },
  computed: {
    _placeHolder() {
      return this.placeholder || this.$t(`搜索商品名称/商家编码`)
    },
  },
  props: {
    placeholder: {
      type: String,
    },
  },
  methods: {
    clear() {
      this.value = undefined
      this.skuList = []
      this.hasSearched = false
    },
    searchSkuNameList: debounce(function (value) {
      if (!value) return
      this.loading = true
      this.hasSearched = true
      let data = {
        keyword: value,
        pageNo: 1,
        pageSize: 100,
      }
      http({
        url: api.skuListForScm,
        type: 'post',
        data,
        hasLoading: false,
        success: (data) => {
          const skuList = data.result?.skuList || []
          this.skuList = skuList
          this.loading = false
        },
      })
    }, 800),

    handleSearch(value) {
      this.searchSkuNameList(value)
    },
    handleChange(value, option) {
      this.value = value
      this.choosedData = option?.data?.attrs?.option
    },
  },
  watch: {
    choosedData(val) {
      this.$emit('selected', deepClone(val || {}))
    },
  },
}
</script>
